import { createSlice } from "@reduxjs/toolkit";

export const surveySlice = createSlice({
    name: "survey",
    initialState: {
        surveyFormState: false,
        surveyLink: "SURVEY_BOT",
    },
    reducers: {
        setSurveyFormState: (state, action) => {
            state.surveyFormState = action.payload;
        },
        setSurveyLinkState: (state, action) => {
            state.surveyLink = action.payload;
        },
    },
});

export const { setSurveyFormState, setSurveyLinkState } = surveySlice.actions;

export default surveySlice.reducer;
